import SolarImg from 'assets/offers/solar.png';
import HeatImg from 'assets/offers/heat.jpeg';
import InvestImg from 'assets/offers/invest.jpg';
import formationImg from 'assets/offers/formation.jpg';
import AssuranceImg from 'assets/offers/assurance.jpg';
import IteImg from 'assets/offers/ite.jpg';
import HabitationImg from 'assets/offers/habitation.jpg';
import AssuranceVieImg from 'assets/offers/assurance-vie.jpg';
import AnimauxImg from 'assets/offers/animaux.jpg';
import AssuranceAutoImg from 'assets/offers/assurance-auto.jpg';
import MutuelleObsImg from 'assets/offers/obsèques.jpg';
import VoyageImg from 'assets/offers/voyage.jpg';
import AssuranceScolaireImg from 'assets/offers/assurance-scolaire.jpg';
import AssuranceRespImg from 'assets/offers/rc.jpg';
import AssuranceEmprunteurImg from 'assets/offers/assurance-emprunteur.jpg';
import AssuranceSenior from 'assets/offers/assurance-senior.jpg';
import MutuelSenior from 'assets/offers/mutuel-senior.jpg';
import PrevoyanceImg from 'assets/offers/prevoyance.jpg';
import RechargeImg from 'assets/offers/recharge.jpg';
import DoucheImg from 'assets/offers/douche.jpg';
import EscalierImg from 'assets/offers/escalier.jpg';
import AuditifImg from 'assets/offers/auditif.jpg';
import IsolationExterneImg from 'assets/offers/isolation-externe.jpg';
import PiscineImg from 'assets/offers/piscine.jpg';
import { getSubIndustryImageUrl } from 'services/industryService';

export const getImage = (industry: string, subIndustry: string) => {
    // Admin-configured image (set on the sub-industry in the back-office) takes priority
    const adminImageUrl = getSubIndustryImageUrl(industry, subIndustry);
    if (adminImageUrl) return adminImageUrl;

    // Normalize strings for comparison (case-insensitive, accent-insensitive)
    const normalize = (str: string) => {
        if (!str) return '';
        return str
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') // Remove accents
            .trim();
    };

    const normalizedIndustry = normalize(industry);
    const normalizedSubIndustry = normalize(subIndustry);

    // Check subIndustry matches first
    if (normalizedSubIndustry.includes('assurance habitation')) return HabitationImg;
    if (normalizedSubIndustry.includes('assurance vie')) return AssuranceVieImg;
    if (normalizedSubIndustry.includes('assurance animaux')) return AnimauxImg;
    if (normalizedSubIndustry.includes('assurance automobile')) return AssuranceAutoImg;
    if (normalizedSubIndustry.includes('mutuelle obseques')) return MutuelleObsImg;
    if (normalizedSubIndustry.includes('assurance voyage')) return VoyageImg;
    if (normalizedSubIndustry.includes('assurance scolaire')) return AssuranceScolaireImg;
    if (normalizedSubIndustry.includes('assurance responsabilite') || normalizedSubIndustry.includes('responsabilite civile'))
        return AssuranceRespImg;
    if (normalizedSubIndustry.includes('assurance emprunteur')) return AssuranceEmprunteurImg;
    if (normalizedSubIndustry.includes('assurance sante senior') || normalizedSubIndustry.includes('assurance senior')) return AssuranceSenior;
    if (normalizedSubIndustry.includes('mutuelle sante senior') || normalizedSubIndustry.includes('mutuelle senior')) return MutuelSenior;
    if (normalizedSubIndustry.includes('prevoyance')) return PrevoyanceImg;
    if (normalizedSubIndustry.includes('borne de recharge') || normalizedSubIndustry.includes('borne recharge')) return RechargeImg;
    if (normalizedSubIndustry.includes('douches securisees') || normalizedSubIndustry.includes('douche')) return DoucheImg;
    if (normalizedSubIndustry.includes('monte') || normalizedSubIndustry.includes('escalier')) return EscalierImg;
    if (normalizedSubIndustry.includes('auditif') || normalizedSubIndustry.includes('appareil')) return AuditifImg;
    if (normalizedSubIndustry.includes('isolation') && normalizedSubIndustry.includes('exterieur'))
        return IsolationExterneImg;
    if (normalizedSubIndustry.includes('panneau') && normalizedSubIndustry.includes('solaire')) return SolarImg;
    if (normalizedSubIndustry.includes('piscine')) return PiscineImg;
    if (normalizedSubIndustry.includes('pompe') && normalizedSubIndustry.includes('chaleur')) return HeatImg;

    // Check industry matches
    if (normalizedIndustry.includes('formation')) return formationImg;
    if (normalizedSubIndustry.includes('renovation') || normalizedSubIndustry === 'ite')
        return IteImg;
    if (normalizedIndustry.includes('assurance')) return AssuranceImg;
    if (normalizedIndustry.includes('investissement')) return InvestImg;
};
